import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AccountOrders from "@/pages/account/AccountOrders";

export const Route = createFileRoute("/account/orders")({
  head: () => pageHead("Account \u2014 Orders \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AccountOrders,
});
